import { Component, OnInit } from '@angular/core';
import { JiraAuthService } from 'src/app/Services/jira-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/Services/shared.service';
import { interval, Subscription } from 'rxjs';
import { ImportMappedProjectService } from 'src/app/Services/import-mapped-project.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-jira-integration-view',
  templateUrl: './jira-integration-view.component.html',
  styleUrls: ['./jira-integration-view.component.scss']
})
export class JiraIntegrationViewComponent implements OnInit {
  brand = getBrand();
  isJiraIntegrationExists: boolean = false;
  jiraIntegrationUrl: string = null;
  returnUrl: string;
  isSyncingInprogress: boolean = false;
  isSyncingCompleted: boolean = false;

  private subscriptions: Subscription = new Subscription();

  constructor(private route: ActivatedRoute,
    private jira_authService: JiraAuthService,
    private sharedService: SharedService,
    private router: Router,
    private mapProjectService: ImportMappedProjectService
  ) { }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/project';
    this.sharedService.loaderHide.emit(true);
    this.subscriptions.add(this.route.queryParams.subscribe(params => {
      if (params["code"]) {
        this.jira_authService.jiraAuthToken(params["code"]).subscribe(data => {
          if (data["data"] == null || data["operationStatus"] == "ERROR") {
            this.isJiraIntegrationExists = false;
            this.getJiraIntegrationUrl();
          } else {
            this.isJiraIntegrationExists = true;
            this.sharedService.loaderHide.emit(false);
          }
          this.navigateToJira();

          // 🔹 Start polling AFTER Jira integration exists
          if (this.isJiraIntegrationExists) {
            this.startPollingIntegrationStatus();
          }
        }, error => {
          this.sharedService.loaderHide.emit(false);
        });
      } else {
        this.checkIsJiraIntegrated();

         // 🔹 Start polling AFTER checking integration
        if (this.isJiraIntegrationExists) {
          this.startPollingIntegrationStatus();
        }
      }
    }));
  }

  startPollingIntegrationStatus(): void {
    // Start polling immediately to get current status
    this.jira_authService.isJiraIntegrationAvailable().subscribe((res: any) => {
      console.log('Initial polling response:', res);
      if (res && res.operationStatus === 'SUCCESS' && res.data) {
        this.isSyncingInprogress = res.data.isSyncingInprogress || false;
        this.isSyncingCompleted = res.data.isSyncingCompleted || false;
      }
    }, error => {
      console.error('Initial polling error:', error);
    });

    // Then start interval polling every 30 seconds
    this.subscriptions.add(
      interval(30000).subscribe(() => {
        this.jira_authService.isJiraIntegrationAvailable().subscribe((res: any) => {
          console.log('Polling response:', res);
          if (res && res.operationStatus === 'SUCCESS' && res.data) {
            this.isSyncingInprogress = res.data.isSyncingInprogress || false;
            this.isSyncingCompleted = res.data.isSyncingCompleted || false;
          }
        }, error => {
          console.error('Polling error:', error);
        });
      })
    );
  }

  checkIsJiraIntegrated() {
    this.jira_authService.isJiraIntegrationAvailable().subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
        this.isJiraIntegrationExists = false;
        this.getJiraIntegrationUrl();
      } else {
        this.isJiraIntegrationExists = true;
        // Set initial sync status from the response
        if (data.data) {
          this.isSyncingInprogress = data.data.isSyncingInprogress || false;
          this.isSyncingCompleted = data.data.isSyncingCompleted || false;
        }
        this.sharedService.loaderHide.emit(false);
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  navigateToJira(): void {
    this.router.navigate([this.router.url.split('?')[0]], { queryParams: {} });
  }

  getJiraIntegrationUrl() {
    this.jira_authService.getJiraIntegrationUrl().subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
        this.jiraIntegrationUrl = null;
      } else {
        this.jiraIntegrationUrl = data["data"];
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  integrateJira(): void {
    this.sharedService.loaderHide.emit(true);
    window.location.href = this.jiraIntegrationUrl;
  }

  navigatePreviousUrl(): void {
    this.router.navigateByUrl(this.returnUrl);
  }

  syncJiraProject(): void {
    this.isSyncingInprogress = true;

    const payload = { project_management_type: 'jira' };
    this.mapProjectService.syncAccountProject(payload)
      .subscribe({
        next: (res: any) => {
          console.log("Sync success:", res);
          // Don't set isSyncingCompleted here as it will be updated by polling
          // The polling will automatically update the status when sync completes
        },
        error: (err) => {
          console.error("Sync error:", err);
          this.isSyncingInprogress = false;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
